"use strict";

exports.__esModule = true;
exports.getFilterTree = getFilterTree;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getFilterTree(treeNodes, filterFunc, filterExpandKeys, keyFunc) {
  var mapFilteredNodeToData = function mapFilteredNodeToData(node) {
    if (!node) return null;
    var match = false;

    if (filterFunc(node)) {
      match = true;
    }

    var children = (node.children || []).map(mapFilteredNodeToData).filter(function (n) {
      return n;
    });

    if (children.length || match) {
      var key = keyFunc(node);
      filterExpandKeys.push(key);
      return _objectSpread({}, node, {
        children: children
      });
    }

    return null;
  };

  return treeNodes.map(mapFilteredNodeToData).filter(function (node) {
    return node;
  });
}